import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// import { useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import TransactionList from "../../../common/TransactionList";
import Constants from "../../../../common/Constants";
import JobCardSearch from "./JobCardSearch";
import JobCardModal from "./JobCardForm";
import ViewJobcardCode from "./ViewJobcardCode";
import ItemService from "../../../../services/commonService";
import { capitalizeFirstWord, formatDateTime } from "../../../../common/Validations";
import { AlertModal } from "../../../common/AlertModal";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { useSelector } from "react-redux";

// import {
//   fetchTransactionListById,
//   searchTransactionListByParam,
// } from "../../../../redux/feature/manufacturing_app/commonTransactionListSlice";

const GenerateJobCard = () => {
  const { t } = useTranslation();
  const [jobCardOpen, setJobCardOpen] = useState(false);
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);
  const [viewJobcardQRValues, setViewJobcardQRValues] = useState([]);
  const [getFilterValue, setFilterValue] = useState([]);
  const [getConfirmValue, setConfirmValue] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [confirmModel, setConfirmModel] = useState(false);
  // const dispatch = useDispatch();
  const [isAlert, setIsAlert] = useState(false);
  const [rowData, setRowData] = useState("");
  // eslint-disable-next-line no-unused-vars
  let userData = useSelector((state) => state?.user); // User Details from Store
const [nofJobCardsToDelete, setNoofJobCardsToDelete] = useState(0);

  const openJobCardForm = () => {
    setJobCardOpen(true);
  };

  const handleClose = () => {
    setJobCardOpen(false);
  };
  const resetAlert = () => {
    setIsAlert(false);
  };

  const handleJobcardPrint = async (row) => {
    let param = {};
    param.url = "getTransactionListDataById";
    param.page = Constants.TRANSACTION.GENERATEJOBCARD.name;
    param.id = row.jobcardCode;

    if (row.jobcardCode) {
      await ItemService.getTransactionListDataById(param).then((item) => {
        // console.log(">> item! getApplicationMaster", item);
        if (item?.status === 200) {
          setOpenViewJobcardCode(true);
          setViewJobcardQRValues(item?.data);
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      });
    }
  };

  const deleteJobcard = async (row) => {
    let param = {};
    param.url = "deleteTransactionListDataById";
    param.page = Constants.TRANSACTION.GENERATEJOBCARD.name;
    param.id = row.jobcardCode;
    param.nofJobCardsToDelete=nofJobCardsToDelete
    if (row.jobcardCode) {
      await ItemService.deleteTransactionListDataById(param).then((item) => {
        // console.log(">> item! getApplicationMaster", item);
        if (item?.status === 200) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            "Jobcard Deleted Successfully",
            2000
          );
          setConfirmModel(false)
          setRefreshKey((prevKey) => prevKey + 1);

        } else {
          console.log(">> Error: While deleting record");
          toastFunc(
            Constants.MASTER.TOAST.error,
            item.message,
            2000
          );
        }
      });
    }
  };

  const handleDelete = () => {
    deleteJobcard(rowData)
  }

  // eslint-disable-next-line no-unused-vars
  const handleJobcardDelete = async (row) => {
    let param = {};
    param.url = "getTransactionListDataById";
    param.page = Constants.TRANSACTION.GENERATEJOBCARD.name;
    param.id = row.jobcardCode;

    if (row.jobcardCode) {
      await ItemService.getTransactionListDataById(param).then((item) => {
        // console.log(">> item! getApplicationMaster", item);
        if (item?.status === 200) {
          const nonOpenJobcards = item?.data.filter(item => item?.jobcardStatus !== "Open");
          if (nonOpenJobcards.length > 0) {
            setIsAlert(true);
          } else {
            setNoofJobCardsToDelete(item?.data?.length)
            setConfirmModel(true);
            setRowData(row)
          }

        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      });
    }
  };

  const handleSearch = (filters) => {
    setFilterValue((prev) => ({
      ...prev,
      ...filters,
    }));
  };

  const handleConfirm = (value) => {
    setConfirmValue(value);
  };

  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <Button variant="primary" onClick={() => handleJobcardPrint(row)}>
            <i className="bi bi-printer-fill"></i>
          </Button> 
          {/* &nbsp;
           {userData?.data?.userId === Constants.MASTER.USERS.ADMIN && <Button variant="danger" onClick={() => handleJobcardDelete(row)}>
            <i className="bi bi-trash3"></i>
          </Button>} */}
        </>
      ),
      width: "120px",
      center: true,
    },

    {
      name: t("msg_trasaction.msg_generatejobcard.customercode"),
      selector: (row) => row.customerCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.customerCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.requiredDate} </p>
        </div>
      ),
    },

    {
      name: t("msg_trasaction.msg_generatejobcard.batchquantityindozens"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.batchTotalQtyDozen}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.Batchtotalquantity"),
      selector: (row) => row.batchTotalQuantity,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.batchTotalQuantity}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.sizeCode} </p>
        </div>
      ),
    },

    {
      name: t("msg_trasaction.msg_generatejobcard.plan"),
      selector: (row) => row.plan,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.plan} </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.planType"),
      selector: (row) => row.planType,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.planType} </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.priority"),
      cell: (row) => (
        <>
          {row.priority === "regular" ? (
            <span className="bg-table-status bg-table-new-status">
              {capitalizeFirstWord(row.priority)}
            </span>
          ) : row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {capitalizeFirstWord(row.priority)}
            </span>
          ) : (
            row.priority
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.siliconize"),
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-info-status">
            {row.siliconize}
          </span>
        </>
      ),
      center: true,
      width: "150px",
    },

    {
      name: t("msg_trasaction.msg_generatejobcard.remarks"),
      selector: (row) => row.remarks,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.remarks} </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.createdDate"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.dbDateTimeCreated)} </p>
        </div>
      ),
    },
  ];

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_trasaction.msg_generatejobcard.generateJobCard")}
            </h2>
            <p className="subText">
              {t("msg_trasaction.msg_generatejobcard.detailedPage")}
            </p>
            <hr />
          </div>
        </Col>
      </Row>

      <div className="jobcard-div">
        <Button variant="primary" onClick={openJobCardForm}>
          {t("msg_trasaction.msg_generatejobcard.generate")}
        </Button>{" "}
        <span>
          {" "}
          <JobCardSearch onSearch={handleSearch} />
        </span>
      </div>
      <br />
      <div>
        <TransactionList
          columnsData={columnsData}
          key={refreshKey} // This forces re-render of the component
          //rowsData={rowsData}
          pageName={t("msg_trasaction.msg_generatejobcard.jobCards")}
          pageURL={Constants.TRANSACTION.GENERATEJOBCARD.list}
          name={Constants.TRANSACTION.GENERATEJOBCARD.name}
          selectableRows
          filterValue={getFilterValue}
          onConfirm={getConfirmValue}
        />
      </div>
      {jobCardOpen && (
        <JobCardModal
          show={jobCardOpen}
          onHide={handleClose}
          onConfirm={handleConfirm}
        />
      )}
      {openViewJobcardCode && (
        <ViewJobcardCode
          selectedItems={viewJobcardQRValues}
          show={openViewJobcardCode}
          onHide={() => {
            resetJobcardModal();
          }}
        ></ViewJobcardCode>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={"This Jobcard is already in Process. You cannot delete"}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={"Delete Jobcard"}
          bodyMessage={"Do you want to Delete Jobcard ?"}
          onOk={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </main>
  );
};

export default GenerateJobCard;
